export const skillPathsPath = (classroomId?: string) =>
  classroomId ? `/classes/${classroomId}/skill-paths` : '/skill-paths';

export const automatedSkillPathsPath = (classroomId?: string) =>
  `${skillPathsPath(classroomId)}/automated`;
